import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/calories-burned-calculator',
  component: () => import('../../routes/CaloriesBurned.svelte'),
  card: {
    id: 'calories-burned',
    title: 'Calories Burned Calculator',
    description: 'Calculate calories burned during any physical activity using the MET formula. Compare workout intensity across 25+ activities.',
    icon: 'local_fire_department',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/calories-burned-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Calories Burned Calculator – MET-Based Workout Calorie Counter',
    description: 'Free calories burned calculator using the scientifically-validated MET (Metabolic Equivalent of Task) formula. Calculate calories burned from running, swimming, cycling, weightlifting, and 20+ activities. Compare workout intensity and find equivalent exercises.',
  },
};

export default meta;